import { FC, PropsWithChildren } from 'react';

import Icon from '../../_common/components/utils/Icon';
import Container from '@carrot-deprecated/container';
import Typography from '@carrot-deprecated/typography';

export const FormFieldErrorMessage: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container flex gap="xs">
      <Icon icon="alert" $size="m" />
      <Typography variant="paragraph" as="span">
        {children}
      </Typography>
    </Container>
  );
};
